import { queryFilterCreate, queryFilterGetInfo } from '../utils/query-utils';

/**
 * @implements {import('./query-utils').IQueryFilterInfo}
 */
export class DatasetQueryFilterInfoStoreable {
    static TYPE = 1;

    __t = DatasetQueryFilterInfoStoreable.TYPE;
    /**
     * @type {import('./query-utils').IQueryFilterInfo['name']}
     */
    name;
    /**
     * @type {import('./query-utils').IQueryFilterInfo['operator']}
     */
    operator;
    /**
     * @type {import('./query-utils').IQueryFilterInfo['value']}
     */
    value;

    /**
     * @param {import('./query-utils').IQueryFilterInfo} options
     */
    constructor(options) {
        // reuse queryFilterCreate util with validation under the hood
        const filter = queryFilterCreate(options);
        const { name, operator, value } = queryFilterGetInfo(filter);
        this.name = name;
        this.operator = operator;
        this.value = value;
    }

    /**
     *
     * @return {import('./query-utils').IQueryFilterInfo & { __t: number }}
     */
    toJSON() {
        const { __t, name, operator, value } = this;
        return {
            __t,
            name,
            operator,
            value
        };
    }

    toString() {
        return JSON.stringify(this.toJSON());
    }
}

/**
 *
 * @param {import('./query-utils').IQueryFilterInfo} options
 * @return {DatasetQueryFilterInfoStoreable}
 */
export const createDatasetQueryFilterStoreable = (options) => {
    return new DatasetQueryFilterInfoStoreable(options);
};
